// extracted by mini-css-extract-plugin
export default {"selectBox":"SelectedResource_selectBox__YyLdp"};